import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import ChatLayout from './components/ChatLayout';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ChatLayout />
    </ThemeProvider>
  );
}

export default App;
